import { atom } from 'jotai';

import { loadSidebarState } from '../index';
export interface SidebarState {
  isOpen: boolean; // Collapse/expand state
  width: number; // Current sidebar width in pixels
  minWidth: number; // Minimum allowed width (e.g., 300px)
  maxWidth: number; // Maximum allowed width (e.g., 600px)
}

export const sidebarStateAtom = atom<SidebarState>(loadSidebarState());
